/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Allocation_SchedulesInputs */

const en_nav_allocation_schedules = /** @type {(inputs: Nav_Allocation_SchedulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allocation setup`)
};

/**
* | output |
* | --- |
* | "Allocation setup" |
*
* @param {Nav_Allocation_SchedulesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_allocation_schedules = /** @type {((inputs?: Nav_Allocation_SchedulesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Allocation_SchedulesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_allocation_schedules(inputs)
});